<template>
  <component
    :is="((currentSite.consumerConfig.collapseOtherTickets && $consumer) || (currentSite.collapseOtherTickets && !$consumer)) && order.user && !combinedTicketSelection ? 'q-expansion-item' : 'div'"
    v-if="order.user || currentSite.allowAnonymousOrders"
    v-model="expand"
    class="select-tickets-container"
    header-class="bg-responsive-grey-2 q-pa-none"
    data-test-id="select-tickets"
  >
    <div
      v-if="!(((currentSite.consumerConfig.collapseOtherTickets && $consumer) || (currentSite.collapseOtherTickets && !$consumer)) && order.user) && !combinedTicketSelection"
      class="text-h6 text-left"
      :class="$q.screen.lt.sm ? 'q-py-sm' : 'q-py-md'"
    >
      {{ order.user ? $t('pages.selectTickets.additionalTickets'): $tc('ticket.ticket', 2) }}
      <div v-if="!$register && staleShowing && showing.loading">
        <q-spinner />
      </div>
    </div>

    <template #header>
      <div
        v-if="!combinedTicketSelection"
        class="text-h6 text-left full-width"
        :class="$q.screen.lt.sm ? 'q-pa-sm' : 'q-pa-md'"
      >
        {{ $t('pages.selectTickets.additionalTickets') }}
      </div>
    </template>
    <div v-if="staleShowing && showing.loading">
      <q-spinner />
    </div>

    <div
      class="q-mb-lg"
    >
      <q-list
        bordered
        separator
        style="full-width"
        :class="$register ? undefined : 'bg-responsive-white'"
      >
        <div
          v-if="ticketTypesAndPackages.length === 0"
          class="q-mt-md q-mb-md text-subtitle2 justify-center row"
        >
          {{ $t('pages.selectTickets.noTicketsMessage') }}
        </div>
        <q-item
          v-for="ticketTypeOrPackage in ticketTypesAndPackages"
          :key="getKeyForTicketOrPackage(ticketTypeOrPackage)"
          :class="{
            'text-grey': !canSelectTicketOrPackage(ticketTypeOrPackage, currentShowing),
            'q-px-sm column': $q.screen.lt.sm
          }"
          :clickable="canSelectTicketOrPackage(ticketTypeOrPackage, currentShowing)"
          @click.stop="addGuestTicketOrPackage(ticketTypeOrPackage, currentShowing)"
        >
          <q-item-section
            :class="$q.screen.lt.sm ? 'q-ml-sm' : undefined"
          >
            <div class="row">
              <!-- Item package name and description -->
              <div
                v-if="isItemPackage(ticketTypeOrPackage)"
                class="col column items-start justify-center"
              >
                <div
                  class="text-subtitle2"
                  style="font-size: 1rem;"
                >
                  {{ ticketTypeOrPackage.name }}
                </div>
                <div
                  v-if="ticketTypeOrPackage.config.show_package_details_during_ticket_selection"
                  class="text-responsive-grey-7 text-subtitle"
                  style="font-size: 13px;"
                >
                  <div
                    v-for="ticketType in ticketTypeOrPackage.ticketTypeDescriptions"
                    :key="ticketType.id"
                  >
                    {{ ticketType.description + ' (Ticket)' }}
                  </div>
                  <div
                    v-for="itemVariation in ticketTypeOrPackage.itemVariationDescription"
                    :key="itemVariation.id"
                  >
                    {{ itemVariation.name }}
                  </div>
                </div>
              </div>
              <div
                v-else
                class="col column items-start justify-center"
              >
                <div
                  class="row column items-start justify-start q-gutter-x-xs"
                >
                  <span
                    class="text-subtitle2"
                    style="font-size: 1rem;"
                  >
                    {{ ticketTypeOrPackage.displayName }}
                  </span>
                  <span
                    v-if="ticketTypeOrPackage.userClass"
                    class="text-responsive-grey-8 text-caption ellipsis-3-lines"
                    style="line-height: 1.1"
                  >
                    {{ ticketTypeOrPackage.userClass.description || ticketTypeOrPackage.userClass.ageDescription }}
                    <q-tooltip>
                      {{ ticketTypeOrPackage.userClass.description || ticketTypeOrPackage.userClass.ageDescription }}
                    </q-tooltip>
                  </span>
                </div>
                <div
                  v-if="ticketRedemption[ticketTypeOrPackage.id] > 0"
                  class="text-grey-7 text-subtitle text-italic"
                  style="font-size: 13px;"
                >
                  <span v-if="ticketVoucherName[ticketTypeOrPackage.id]">{{ order.remainingVouchers && !!order.remainingVouchers[ticketVoucherId[ticketTypeOrPackage.id]] && !!order.remainingVouchers[ticketVoucherId[ticketTypeOrPackage.id]].count && order.remainingVouchers[ticketVoucherId[ticketTypeOrPackage.id]].count !== 0 ? order.remainingVouchers[ticketVoucherId[ticketTypeOrPackage.id]].count + 'x ' : '' }}{{ ticketVoucherName[ticketTypeOrPackage.id] }} voucher{{ (order.remainingVouchers && !!order.remainingVouchers[ticketVoucherId[ticketTypeOrPackage.id]] && !!order.remainingVouchers[ticketVoucherId[ticketTypeOrPackage.id]].count && !(order.remainingVouchers[ticketVoucherId[ticketTypeOrPackage.id]].count > 1) ? '' : 's') }} available</span>
                  <br v-if="ticketVoucherName[ticketTypeOrPackage.id] && ticketDiscountName[ticketTypeOrPackage.id]">
                  <span v-if="ticketDiscountName[ticketTypeOrPackage.id]">{{ order.remainingDiscounts && !!order.remainingDiscounts[ticketDiscountId[ticketTypeOrPackage.id]] && !!order.remainingDiscounts[ticketDiscountId[ticketTypeOrPackage.id]].count && order.remainingDiscounts[ticketDiscountId[ticketTypeOrPackage.id]].count !== 0 ? order.remainingDiscounts[ticketDiscountId[ticketTypeOrPackage.id]].count + 'x ' : '' }}{{ ticketDiscountName[ticketTypeOrPackage.id] }} discount{{ (order.remainingDiscounts && !!order.remainingDiscounts[ticketDiscountId[ticketTypeOrPackage.id]] && !!order.remainingDiscounts[ticketDiscountId[ticketTypeOrPackage.id]].count && !(order.remainingDiscounts[ticketDiscountId[ticketTypeOrPackage.id]].count > 1) ? '' : 's') }} available</span>
                </div>
              </div>
            </div>
          </q-item-section>
          <q-item-section
            :side="$q.screen.gt.xs"
            :class="$q.screen.lt.sm ? 'q-pt-sm' : undefined"
          >
            <div
              class="row text-responsive"
              :style="{ 'min-width': minWidth }"
            >
              <!-- Package price -->
              <div
                v-if="isItemPackage(ticketTypeOrPackage) && packagePricing && packagePricing[ticketTypeOrPackage.id]"
                class="col column justify-center"
                :class="$q.screen.lt.sm ? 'items-start' : 'items-center'"
              >
                <div class="text-body1 text-weight-bolder">
                  <span
                    v-if="!packagePricing[ticketTypeOrPackage.id].displayPrice"
                    style="font-size: 1.25rem; line-height: 1.25rem;"
                  >
                    {{ $_.toUpper($t('pricing.free')) }}
                  </span>
                  <div
                    v-else
                    class="column justify-center"
                    :class="$q.screen.lt.sm ? 'items-start' : 'items-center'"
                  >
                    <div
                      :class="{ 'q-pt-xs': packagePricing[ticketTypeOrPackage.id].displayTotal > 0 }"
                      style="font-size: 1.25rem; line-height: 1.25rem;"
                    >
                      <span v-if="packagePricing[ticketTypeOrPackage.id].displayTotal === 0">{{ $_.toUpper($t('pricing.free')) }}</span>
                      <i18n-n
                        v-else
                        :value="packagePricing[ticketTypeOrPackage.id].displayTotal || 0"
                        format="currency"
                        scope="global"
                      />
                    </div>
                  </div>
                  <div
                    v-if="packagePricing[ticketTypeOrPackage.id].discountAmount > 0"
                    class="column items-center justify-center"
                    style="font-size: 0.9rem; line-height: 1.0rem;"
                  >
                    <i18n-n
                      class="text-strike text-responsive-grey"
                      tag="span"
                      :value="packagePricing[ticketTypeOrPackage.id].displayTotal + packagePricing[ticketTypeOrPackage.id].discountAmount"
                      format="currency"
                      scope="global"
                    />
                    <div
                      class="q-pl-xs text-red"
                    >
                      <span>-</span>
                      <i18n-n
                        class="text-red"
                        tag="span"
                        :value="packagePricing[ticketTypeOrPackage.id].discountAmount || 0"
                        format="currency"
                        scope="global"
                      />
                    </div>
                  </div>
                  <div
                    v-if="showTicketPriceBreakdown(ticketTypeOrPackage)"
                    class="text-caption text-responsive-grey-8"
                    style="line-height: 1rem;"
                  >
                    (<i18n-n
                      tag="span"
                      :value="packagePricing[ticketTypeOrPackage.id].displayTotal - packagePricing[ticketTypeOrPackage.id].discountAmount - packagePricing[ticketTypeOrPackage.id].bookingFeeAmount"
                      format="currency"
                    /> +
                    <i18n-n
                      tag="span"
                      :value="packagePricing[ticketTypeOrPackage.id].bookingFeeAmount"
                      format="currency"
                    />
                    {{ packagePricing[ticketTypeOrPackage.id].bookingFeeNames.join(', ') }})
                  </div>
                </div>
              </div>
              <!-- Ticket price -->
              <div
                v-else
                class="col column justify-center"
                :class="$q.screen.lt.sm ? 'items-start' : 'items-center'"
              >
                <div
                  class="text-body1 text-weight-bolder"
                  data-test-id="ticket-price"
                >
                  <span
                    v-if="ticketPrice[ticketTypeOrPackage.id] === 0"
                    style="font-size: 1.25rem; line-height: 1.25rem;"
                  >
                    {{ $_.toUpper($t('pricing.free')) }}
                  </span>
                  <div v-else-if="!ticketPrice[ticketTypeOrPackage.id]">
                    <i18n-n
                      class="text-grey"
                      tag="span"
                      :value="ticketTypeOrPackage.price || 0"
                      format="currency"
                      scope="global"
                    />
                  </div>
                  <div
                    v-else
                    class="column justify-center"
                    :class="$q.screen.lt.sm ? 'items-start' : 'items-center text-center'"
                  >
                    <div
                      class="text-weight-bolder"
                      :class="{ 'q-pt-xs': ticketRedemption[ticketTypeOrPackage.id] > 0 }"
                      :style="{ 'font-size': $q.screen.xs ? '1.15rem': '1.2rem' }"
                      style="line-height: 1.2;"
                    >
                      <span v-if="(ticketPrice[ticketTypeOrPackage.id] - ticketRedemption[ticketTypeOrPackage.id]) === 0">{{ $_.toUpper($t('pricing.free')) }}</span>
                      <i18n-n
                        v-else
                        :value="ticketPrice[ticketTypeOrPackage.id] - ticketRedemption[ticketTypeOrPackage.id]"
                        format="currency"
                        scope="global"
                      />
                    </div>

                    <div
                      v-if="ticketRedemption[ticketTypeOrPackage.id] > 0"
                      class="row items-center justify-center"
                      style="font-size: 0.9rem; line-height: 1.1;"
                    >
                      <i18n-n
                        class="text-strike text-grey"
                        tag="span"
                        :value="ticketPrice[ticketTypeOrPackage.id] || 0"
                        format="currency"
                        scope="global"
                      />
                      <div
                        class="q-pl-xs text-red"
                      >
                        <span>-</span>
                        <i18n-n
                          class="text-red"
                          tag="span"
                          :value="ticketRedemption[ticketTypeOrPackage.id] || 0"
                          format="currency"
                          scope="global"
                        />
                      </div>
                    </div>

                    <div
                      v-if="showTicketPriceBreakdown(ticketTypeOrPackage)"
                      class="text-caption text-responsive-grey-8"
                      style="line-height: 1rem;"
                    >
                      (<i18n-n
                        tag="span"
                        :value="ticketPrice[ticketTypeOrPackage.id] - ticketRedemption[ticketTypeOrPackage.id] - ticketBookingFeePrice[ticketTypeOrPackage.id]"
                        format="currency"
                      /> +
                      <i18n-n
                        tag="span"
                        :value="ticketBookingFeePrice[ticketTypeOrPackage.id]"
                        format="currency"
                      />
                      {{ ticketBookingFeeName[ticketTypeOrPackage.id] }})
                    </div>
                  </div>
                </div>
              </div>
              <!-- Add/remove ticket buttons -->
              <div
                class="col-auto row justify-center items-center"
                :style="{ 'min-width': shouldShowAddAndRemoveButtons ? $q.screen.lt.lg ? '98px' : '108px' : undefined }"
              >
                <q-btn
                  v-if="!selectionCount(ticketTypeOrPackage) || !shouldShowAddAndRemoveButtons "
                  class="col-auto row items-center q-ml-sm"
                  style="max-width: 108px; min-width: 50px;"
                  :style="{ width: $q.screen.lt.lg ? undefined : '100%' }"
                  :label="!canSelectTicketOrPackage(ticketTypeOrPackage, currentShowing) ? $t('status.unavailable') : $t('actions.add')"
                  :square="$register"
                  :rounded="!$register"
                  :outline="canSelectTicketOrPackage(ticketTypeOrPackage, currentShowing) && $register"
                  :color="canSelectTicketOrPackage(ticketTypeOrPackage, currentShowing) && !$register ? 'responsive-grey-2' : undefined"
                  text-color="responsive"
                  :flat="!canSelectTicketOrPackage(ticketTypeOrPackage, currentShowing)"
                  :disable="!canSelectTicketOrPackage(ticketTypeOrPackage, currentShowing)"
                  data-test-id="select-tickets-add-button"
                  @click.stop="addGuestTicketOrPackage(ticketTypeOrPackage, currentShowing)"
                />
                <template v-else>
                  <q-btn
                    class="col-auto"
                    :icon="selectionCount(ticketTypeOrPackage) > 1 ? 'fal fa-minus' : 'fal fa-trash-can'"
                    dense
                    :square="$register"
                    :outline="$register"
                    :round="!$register"
                    :color="!$register ? 'responsive-grey-2' : undefined"
                    text-color="responsive"
                    :disable="!canRemoveGuestTicketOrPackage(ticketTypeOrPackage, currentShowing)"
                    @click.stop="removeGuestTicketOrPacakge(ticketTypeOrPackage, currentShowing)"
                  />
                  <div
                    v-if="selectionCount(ticketTypeOrPackage)"
                    class="col-auto text-center"
                    :class="$register ? 'text-bold' : undefined"
                    :style="{
                      width: $q.screen.lt.lg ? '25px' : '44px',
                      'font-size': $q.screen.lt.lg ? '1.1rem' : '1.25rem'
                    }"
                    style="line-height:2rem"
                    data-test-id="select-tickets-count"
                  >
                    {{ selectionCount(ticketTypeOrPackage) }}
                  </div>
                  <q-btn
                    class="col-auto"
                    icon="fal fa-plus"
                    dense
                    :square="$register"
                    :outline="$register"
                    :round="!$register"
                    :color="!$register ? 'responsive-grey-2' : undefined"
                    text-color="responsive"
                    :disable="!canSelectTicketOrPackage(ticketTypeOrPackage, currentShowing)"
                    @click.stop="addGuestTicketOrPackage(ticketTypeOrPackage, currentShowing)"
                  />
                </template>
              </div>
            </div>
          </q-item-section>
        </q-item>
      </q-list>
    </div>
  </component>
</template>

<script>
import { useRemoveOrderItem } from 'src/composables/order/order-items/RemoveOrderItem'
import { canSelectTicketTypeOrPackage } from 'src/models/order/CheckoutData'

export default {
  name: 'SelectTickets',
  inject: ['order', 'checkoutData'],
  props: {
    showing: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      required: false,
      default: null
    },
    staleShowing: {
      type: Object,
      required: false,
      default () {
        return null
      }
    },
    ticketsAllowed: {
      type: Boolean,
      required: false,
      default: true
    },
    ticketOrderItems: {
      type: Array,
      required: true,
      null: false
    },
    packagePricing: {
      type: Object,
      required: true,
      null: false
    },
    initialNumOfTicketsToSelect: {
      type: Number,
      required: false,
      default: 0
    },
    combinedTicketSelection: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['request-authorization'],
  setup () {
    const { removeOrderItem } = useRemoveOrderItem()
    return {
      removeOrderItem
    }
  },
  data () {
    return {
      expand: false
    }
  },
  configuration: ['currentSite'],
  context: ['currentUser'],
  computed: {
    minWidth () {
      if (this.$kiosk) return '300px'
      if (this.$q.screen.xs) return '170px'
      if (this.$q.screen.lt.lg) return '200px'
      return '300px'
    },
    currentShowing () {
      if (this.showing?.loading && this.staleShowing) {
        return this.staleShowing
      } else {
        return this.showing
      }
    },
    ticketTypes () {
      return this.currentShowing.ticketTypes('guest')
    },
    packages () {
      return this.currentShowing.packages('guest')
    },
    ticketTypesAndPackages () {
      const ticketTypes = this.currentShowing.ticketTypes('guest', true)
      const packages = this.currentShowing.packages('guest', true)

      return _(ticketTypes)
        .concat(packages)
        .sortBy(([displayOrder, ticketOrPackage]) => displayOrder)
        .map(([displayOrder, ticketOrPackage]) => ticketOrPackage)
        .filter(this.ticketOrPackageIsAvailableForSelectedSeats)
        .value()
    },
    ticketPrice () {
      const prices = {}
      _.each(this.ticketOrderItems, ticketOrderItem => {
        prices[ticketOrderItem.ticket.ticketType.id] = ticketOrderItem.displayPrice
      })
      return prices
    },
    ticketRedemption () {
      const prices = {}
      _.each(this.ticketOrderItems, ticketOrderItem => {
        prices[ticketOrderItem.ticket.ticketType.id] = ticketOrderItem.displayRedemptionTotal
      })
      return prices
    },
    ticketVoucherId () {
      const redemptionCodes = {}
      _.each(this.ticketOrderItems, ticketOrderItem => {
        redemptionCodes[ticketOrderItem.ticket.ticketType.id] = ticketOrderItem.voucher?.voucherType?.id || ticketOrderItem.voucherType?.id
      })
      return redemptionCodes
    },
    ticketDiscountId () {
      const redemptionCodes = {}
      _.each(this.ticketOrderItems, ticketOrderItem => {
        redemptionCodes[ticketOrderItem.ticket.ticketType.id] = ticketOrderItem.discount?.id
      })
      return redemptionCodes
    },
    ticketVoucherName () {
      const voucherNames = {}
      _.each(this.ticketOrderItems, ticketOrderItem => {
        voucherNames[ticketOrderItem.ticket.ticketType.id] = ticketOrderItem.displayVoucherName
      })
      return voucherNames
    },
    ticketDiscountName () {
      const discountNames = {}
      _.each(this.ticketOrderItems, ticketOrderItem => {
        discountNames[ticketOrderItem.ticket.ticketType.id] = ticketOrderItem.displayDiscountName
      })
      return discountNames
    },
    ticketBookingFeePrice () {
      const bookingFeePrices = {}
      _.each(this.ticketOrderItems, ticketOrderItem => {
        bookingFeePrices[ticketOrderItem.ticket.ticketType.id] = ticketOrderItem.bookingFeeDisplayPrice
      })
      return bookingFeePrices
    },
    ticketBookingFeeIncluded () {
      const bookingFeeIncluded = {}
      _.each(this.ticketOrderItems, ticketOrderItem => {
        bookingFeeIncluded[ticketOrderItem.ticket.ticketType.id] = ticketOrderItem.includeBookingFeeInPrice
      })
      return bookingFeeIncluded
    },
    ticketBookingFeeName () {
      const bookingFeeNames = {}
      _.each(this.ticketOrderItems, ticketOrderItem => {
        bookingFeeNames[ticketOrderItem.ticket.ticketType.id] = (ticketOrderItem.orderItemBookingFee?.bookingFeeType || ticketOrderItem.localBookingFeeType)?.name
      })
      return bookingFeeNames
    },
    shouldShowAddAndRemoveButtons () {
      if (!this.showing.reservedSeating || this.currentSite.consumerConfig.showTicketFirstCheckoutFlow) return true

      return this.initialNumOfTicketsToSelect !== 1
    }
  },
  methods: {
    toggleExpand (show = !this.expand) {
      this.expand = show
    },
    showTicketPriceBreakdown (ticketTypeOrPackage) {
      if (this.isItemPackage(ticketTypeOrPackage)) {
        return this.packagePricing[ticketTypeOrPackage.id].bookingFeeAmount > 0
      } else {
        return this.ticketBookingFeeIncluded[ticketTypeOrPackage.id] && this.ticketBookingFeePrice[ticketTypeOrPackage.id] > 0
      }
    },
    canSelectTicketOrPackage (ticketTypeOrPackage, showing) {
      if (!this.ticketsAllowed) return

      if (this.isItemPackage(ticketTypeOrPackage)) {
        return this.order.canAddItemPackage(ticketTypeOrPackage, showing)
      } else {
        return this.order.ticketsRemaining(showing, ticketTypeOrPackage) > 0
      }
    },
    ticketOrPackageIsAvailableForSelectedSeats (ticketTypeOrPackage) {
      if (!this.showing.reservedSeating || _.isNil(this.checkoutData) || this.currentSite.consumerConfig.showTicketFirstCheckoutFlow) return true

      return canSelectTicketTypeOrPackage(this.order, this.showing, ticketTypeOrPackage, this.checkoutData.selectedSeatsForShowingId(this.showing.id), this.currentSite.consumerConfig.showTicketFirstCheckoutFlow)
    },
    canRemoveGuestTicketOrPackage (ticketTypeOrPackage, showing) {
      if (this.isItemPackage(ticketTypeOrPackage)) {
        return this.order.canRemoveTicketPackage(showing, ticketTypeOrPackage)
      } else {
        return this.order.canRemoveGuestTicket(showing, ticketTypeOrPackage)
      }
    },
    isItemPackage (object) {
      if (typeof object === 'object') {
        return object.constructor.name === 'ItemPackage'
      } else {
        return false
      }
    },
    getKeyForTicketOrPackage (ticketTypeOrPackage) {
      return `${ticketTypeOrPackage.constructor.name}-${ticketTypeOrPackage.id}`
    },
    selectionCount (ticketTypeOrPackage) {
      if (this.isItemPackage(ticketTypeOrPackage)) {
        return this.packageSelectionCount(ticketTypeOrPackage)
      } else {
        return _.filter(this.order.orderItems.data, (orderItem) => {
          return orderItem.state === 'draft' && orderItem.type === 'ticket' &&
          orderItem.ticket.showing.id === this.currentShowing.id &&
          !orderItem.ticket.user && orderItem.ticket.ticketType.id === ticketTypeOrPackage.id
        }).length
      }
    },
    packageSelectionCount (packageItem) {
      const length = _.filter(this.order.orderItems.data, (orderItem) => {
        return orderItem.state === 'draft' && orderItem.type === 'ticket' &&
          orderItem.itemPackage?.id === packageItem.id &&
          orderItem.ticket.showing.id === this.currentShowing.id
      }).length

      if (length === 0) return length

      return length / _.filter(packageItem.itemPackageItems.data, 'ticketType').length
    },
    addGuestTicket (showing, ticketType) {
      if (this.$register && !this.currentUser.admin && ticketType.requiresAuthorization) {
        this.$emit('request-authorization', () => this.order.addGuestTicket(showing, ticketType))
      } else {
        this.order.addGuestTicket(showing, ticketType)
      }
    },
    addGuestTicketOrPackage (ticketTypeOrPackage, showing) {
      if (this.isItemPackage(ticketTypeOrPackage)) {
        return this.order.addItemPackage(ticketTypeOrPackage, showing)
      } else {
        return this.addGuestTicket(showing, ticketTypeOrPackage)
      }
    },
    removeGuestTicketOrPacakge (ticketTypeOrPackage, showing) {
      if (this.isItemPackage(ticketTypeOrPackage)) {
        const orderItem = this.order.findPackageTicketOrderItem(showing, ticketTypeOrPackage)
        this.removeOrderItem(orderItem)
      } else {
        const orderItem = this.order.findGuestTicketOrderItem(showing, ticketTypeOrPackage)
        this.removeOrderItem(orderItem)
      }
    },
    getTicketOrPackagePrice (ticketTypeOrPackage) {
      if (this.isItemPackage(ticketTypeOrPackage)) {
        return this.packagePrice[ticketTypeOrPackage.id]
      } else {
        return this.ticketPrice[ticketTypeOrPackage.id]
      }
    }
  }
}

</script>

<style lang="scss" scoped>
  .q-btn--dense.q-btn--round.col-auto {
    padding: 0;
    min-height: 2.4em;
    min-width: 2.4em
  }
</style>
